import { closest, dispatchEvent } from '@nrk/dh-basis-common'

export function setupClickNavigator(app) {
  let prevPosition, pointerMovement

  const handlePointerMove = (e) => {
    const { clientX, clientY } = e
    const movementX = clientX - prevPosition.clientX
    const movementY = clientY - prevPosition.clientY
    pointerMovement += Math.abs(movementX) + Math.abs(movementY)
    prevPosition = { clientX, clientY }
  }

  const handlePointerUp = () => {
    app.removeEventListener('pointermove', handlePointerMove)
    app.removeEventListener('pointerup', handlePointerUp)
  }

  const handlePointerDown = (e) => {
    const { clientX, clientY } = e
    prevPosition = { clientX, clientY }
    pointerMovement = 0
    app.addEventListener('pointermove', handlePointerMove)
    app.addEventListener('pointerup', handlePointerUp)
  }

  const handleBackgroundClick = (e) => {
    app.removeEventListener('pointermove', handlePointerMove)
    const anchor = closest(e.target, 'a, button, input')
    if (anchor || pointerMovement > 10) {
      return
    }
    e.stopPropagation()
    e.preventDefault()
    const isLeft = e.clientX < window.innerWidth / 3
    if (isLeft) {
      app._navigateUp()
    } else {
      app._navigateDown()
    }
    dispatchEvent(app, 'dh-kortstokk-click-navigation')
  }
  app.addEventListener('pointerdown', handlePointerDown)
  app.addEventListener('click', handleBackgroundClick)

  return () => {
    app.removeEventListener('pointerdown', handlePointerDown)
    app.removeEventListener('click', handleBackgroundClick)
  }
}
